import StyledCard from "components/UI/StyledCard";
import { GridColDef } from '@mui/x-data-grid-premium'
import CheckIcon from '@mui/icons-material/Check'
import { getIn } from "components/Formik/forms";
import { useMemo } from "react";
import { CopyValueCell } from "./common/CopyValueCell";
import { getRequestParameterRows } from "./data/helper";
import TreeDataGrid from "./common/TreeDataGrid";
import { useOrbit } from "providers/OrbitProvider";


const requestParameterColumns: GridColDef[] = [
  {
    field: "name",
    groupable: true,
    headerName: "Field",
    flex: 1.75,
    cellClassName: 'code-text bold',
    renderCell: (params) => {
      // hide values for subgroups
      if (params.rowNode?.depth > 0) {
        return ''
      }
      return params.value;
    },
  },
  {
    field: "required",
    groupable: false,
    headerName: "Required",
    flex: .75,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      if (params.value === true) {
        return <CheckIcon sx={{ verticalAlign: 'text-bottom' }} />
      }
      return '';
    },
  },
  {
    field: "description",
    groupable: false,
    headerName: "Description",
    cellClassName: 'bold',
    flex: 1.5,
    colSpan: (_value, row) => {
      // if it's a top level row, increase the column span
      if (row.path.length === 1) {
        return 3;
      }
      return undefined;
    }
  },
  {
    field: "value",
    groupable: false,
    headerName: "Value",
    flex: 1.5,
    cellClassName: 'code-text bold',
    renderCell: CopyValueCell,
  },
  {
    field: "text",
    groupable: false,
    headerName: "Value Detail",
    flex: 3.5,
  },
  {
    field: '__tree_data_group__', // The grouping column (used to order it last)
    width: 100
  }
]

export function RequestParameters({clientCampaigns, fields, degreePrograms, leadsEndpoint}) {
  const { getRemoteId } = useOrbit()

  const rows = useMemo(() => getRequestParameterRows({
    clientCampaigns: clientCampaigns,
    fields: fields,
    degreePrograms: degreePrograms,
    parameterNames: getIn(leadsEndpoint, 'attributes.parameterNames') || {},
    getRemoteId,
  }), [clientCampaigns, fields, degreePrograms, leadsEndpoint, getRemoteId])

  return (
    <StyledCard
    title='Request Parameters'
    isSubsection={true}
    >
      <TreeDataGrid
        rows={rows}
        columns={requestParameterColumns}
      />
    </StyledCard>
  )
}
